// The implementation will be filled in shell/src/api/api.ts.
module.exports = {
    __esModule: true,
    default: {}
};
